import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, catchError } from 'rxjs';
import { Observable, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { getPreferredUserIdentifier, buildAetUserContext } from '../core/constant/user-context.util';

@Injectable({
  providedIn: 'root',
})
export class ReportsCommonService {
  UrlOrderSupplier: any[] = [];
  UrlOrderPlant: any[] = [];
  UrlOrderRegion: any[] = [];
  UrlOrderVendor: any[] = [];
  UrlOrderStatus: any[] = [];

  private readonly trialUpdateObservable = new BehaviorSubject<any>(null);
  trialUpdateData = this.trialUpdateObservable.asObservable();

  constructor(private readonly http: HttpClient) {}

  private baseURL = environment.baseAPIURL;

  updateTrialChanges(data: any) {
    this.trialUpdateObservable.next(data);
  }

  borderCrossingReport(params: {
    supplier: any;
    plantCode: any;
    logisticsPoint: any;
    reportRegion: any;
    orderVendor: any;
    reportStatus: any;
    startDate: string;
    endDate: string;
  }) {
    const url: string = this.baseURL + `/aetReport/aetBorderCrossing`;
    const rb = { event: params, userReqDto: buildAetUserContext() };
    return this.http.post(url, rb, { observe: 'response', responseType: 'json' }).pipe(catchError(this.handleError));
  }

  getCommonReport(toyotaGUID: string): Observable<any> {
    const userIdentifier = getPreferredUserIdentifier(toyotaGUID);
    const url: string = this.baseURL + `/aetReports/getAetReportsSetup?upn=${userIdentifier}`;

    return this.http.get(url, { observe: 'response', responseType: 'json' }).pipe(catchError(this.handleError));
  }

  getCommonReportByUser(user: any): Observable<any> {
    const url: string = this.baseURL + `/aetReports/getAetReportsSetup`;
    const rb = { event: user, userReqDto: buildAetUserContext() };
    return this.http.post(url, rb, { observe: 'response', responseType: 'json' }).pipe(catchError(this.handleError));
  }

  public downloadFile(user: any, params: any) {
    this.UrlOrderSupplier = [];
    params.supplier.forEach((id) => {
      this.UrlOrderSupplier.push(id.label);
    });

    this.UrlOrderPlant = [];
    params.plant.forEach((id) => {
      this.UrlOrderPlant.push(id.label);
    });

    this.UrlOrderRegion = [];
    params.region.forEach((id) => {
      this.UrlOrderRegion.push(id.label);
    });

    this.UrlOrderVendor = [];
    params.transport_Provider.forEach((id) => {
      this.UrlOrderVendor.push(id.label);
    });

    this.UrlOrderStatus = [];
    params.status.forEach((id) => {
      this.UrlOrderStatus.push(id.label);
    });

    const OrderResponseBody = {
      supplier: this.UrlOrderSupplier,
      plantCode: this.UrlOrderPlant,
      reportRegion: this.UrlOrderRegion,
      orderVendor: this.UrlOrderVendor,
      reportStatus: this.UrlOrderStatus,
      startDate: params.startDate,
      endDate: params.endDate,
    };

    const rb = { event: OrderResponseBody, userReqDto: buildAetUserContext() };
    const url: string = this.baseURL + `/aetReport/aetOrderInformation`;

    return this.http.post(url, rb, { observe: 'response', responseType: 'blob' }).pipe(catchError(this.handleError));
  }

  private handleError(error: HttpErrorResponse) {
    return throwError(() => new Error(error.message || 'Server Error'));
  }
}
